// @ts-nocheck
// Starter Sync - VmiUsersHeader

import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import updateSearchFields from "@insite/client-framework/Store/Pages/VmiUsers/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import { vmiSearchAndFilterProps } from "@store/Themes/common/props/vmi";
import React, { useState } from "react";

const searchMinimumCharacterLength = 3;

export interface VmiUsersSearchBoxStyles {
    searchContainer?: GridContainerProps;
    searchGridItem?: GridItemProps;
    searchText?: TextFieldPresentationProps;
}

export const vmiUsersSearchBoxStyles: VmiUsersSearchBoxStyles = {
    searchContainer: vmiSearchAndFilterProps.searchContainer,
    searchGridItem: vmiSearchAndFilterProps.searchGridItem,
    searchText: vmiSearchAndFilterProps.searchText,
};

const styles = vmiUsersSearchBoxStyles;

const VmiUsersSearchBox = () => {
    const dispatch = useAppDispatch();
    const searchText = useAppSelector(state => state.pages.vmiUsers.getVmiUsersParameter.searchText);

    const [searchTimeoutId, setSearchTimeoutId] = useState<NodeJS.Timeout | undefined>(undefined);
    const [searchUserText, setSearchUserText] = useState(searchText);

    const searchTextChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        clearTimeout(searchTimeoutId);

        const searchText = event.currentTarget.value;
        setSearchUserText(searchText);
        if (searchText.length > 0 && searchText.length < searchMinimumCharacterLength) {
            return;
        }

        setSearchTimeoutId(
            setTimeout(() => {
                dispatch(
                    updateSearchFields({
                        searchText,
                        page: 1,
                    }),
                );
            }, constants.searchDebounceDelay),
        );
    };

    return (
        <GridContainer {...styles.searchContainer}>
            <GridItem {...styles.searchGridItem} data-test-selector="vmiUsersHeader_searchGridItem">
                <TextField
                    placeholder={translate("Type to search")}
                    {...styles.searchText}
                    value={searchUserText}
                    onChange={searchTextChangeHandler}
                    label={translate("Search Users")}
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: VmiUsersSearchBox,
    definition: {
        group: "VMI Users",
        displayName: "Search Box",
        allowedContexts: ["VmiUsersPage"],
    },
};

export default widgetModule;
